var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view--events"},[_c('data-table',{staticClass:"has-margin-b45",attrs:{"data":_vm.tableData},on:{"sort":_vm.sortDataTable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }